import { Query_Root } from 'src/@types/graphql'
import { FetchRowsPromise } from 'src/screens/pf-kap/index/PfKapGridUtils'
import { fetchPfPgvProjectsGrid } from 'src/screens/shared/project/index/projectGridQueries'
import { Client } from 'urql'

export const fetchPfPgvRows =
  (urqlClient: Client) =>
  async (isGfsUser: boolean): Promise<FetchRowsPromise> => {
    const { data, error } = await urqlClient
      .query<
        {
          pf_pgv_project: Query_Root['pf_pgv_project']
        },
        {
          isGfsUser: boolean
        }
      >(fetchPfPgvProjectsGrid, {
        isGfsUser,
      })
      .toPromise()

    if (error) {
      return Promise.reject(error)
    } else {
      const fetchedRows = data!.pf_pgv_project.map((p) => ({
        id: p.id,
        status: p.project_base.dossier.status,
        short_title: p.project_base.dossier.short_title,
        gfch_responsible: `${p?.project_base?.gfch_responsible?.first_name ?? ''} ${
          p?.project_base?.gfch_responsible?.last_name ?? ''
        }`,
        funding_round_name: p?.project_base?.dossier?.funding_round?.name ?? '',
        application_type: p?.application_type?.key ?? '',
        curr_milestone_type: p?.project_base.dossier.first_open_milestone?.[0]?.type,
        curr_milestone_year: p?.project_base.dossier.first_open_milestone?.[0]?.year_in_focus,
      }))
      return {
        rows: fetchedRows,
      }
    }
  }
